import en from './en.json';
import fr from './fr.json';
import es from './es.json';
import zh from './zh.json';
import ar from './ar.json';
import pa from './pa.json';
import tl from './tl.json';
import vi from './vi.json';
import zhHK from './zh-HK.json';
import tr from './tr.json';
import uk from './uk.json';
import hi from './hi.json';
import ur from './ur.json';
import ko from './ko.json';
import pt from './pt.json';
import bn from './bn.json';
import fa from './fa.json';
import pl from './pl.json';
import ru from './ru.json';
import so from './so.json';
import am from './am.json';

/** @type {import('vue-i18n').LocaleMessages} */
export const messages = {
  en,
  fr,
  es,
  zh,
  ar,
  pa,
  tl,
  vi,
  'zh-HK': zhHK,
  tr,
  uk,
  hi,
  ur,
  ko,
  pt,
  bn,
  fa,
  pl,
  ru,
  so,
  am
};

/**
 * BCP 47 locale codes supported by the tour app.
 * Regions reflect primary diaspora / usage notes from product requirements.
 */
export const SUPPORTED_LOCALES = [
  { code: 'en', name: 'English' },
  { code: 'fr', name: 'French', regions: 'Canada, France, Europe' },
  { code: 'es', name: 'Spanish', regions: 'USA, Western Europe' },
  { code: 'zh', name: 'Mandarin', regions: 'North America, Australia, Europe' },
  { code: 'ar', name: 'Arabic', regions: 'France, Germany, Sweden, Europe' },
  { code: 'pa', name: 'Punjabi', regions: 'Canada, UK' },
  { code: 'tl', name: 'Tagalog (Filipino)', regions: 'USA, Canada, Middle East' },
  { code: 'vi', name: 'Vietnamese', regions: 'USA, Australia, France, Germany' },
  { code: 'zh-HK', name: 'Cantonese', regions: 'Canada, USA, UK' },
  { code: 'tr', name: 'Turkish', regions: 'Germany, Austria, Netherlands' },
  { code: 'uk', name: 'Ukrainian', regions: 'Poland, Germany, Czechia, Canada' },
  { code: 'hi', name: 'Hindi', regions: 'USA, UK, UAE' },
  { code: 'ur', name: 'Urdu', regions: 'UK, Gulf States' },
  { code: 'ko', name: 'Korean', regions: 'USA, China, Japan' },
  { code: 'pt', name: 'Portuguese', regions: 'USA, Japan, Western Europe' },
  { code: 'bn', name: 'Bengali', regions: 'UK, USA, Gulf States' },
  { code: 'fa', name: 'Persian (Farsi)', regions: 'USA, Germany, Sweden' },
  { code: 'pl', name: 'Polish', regions: 'UK, Ireland, Iceland, Norway' },
  { code: 'ru', name: 'Russian', regions: 'Germany, Israel, USA, Estonia' },
  { code: 'so', name: 'Somali', regions: 'USA (Minnesota), Sweden, UK' },
  { code: 'am', name: 'Amharic', regions: 'USA, Israel' }
];

export const DEFAULT_LOCALE = 'en';

export const isSupportedLocale = (code) =>
  SUPPORTED_LOCALES.some((locale) => locale.code === code);

export const normalizeLocale = (code) =>
  (code && isSupportedLocale(code) ? code : DEFAULT_LOCALE);
